// Module-level registry for the running dictation session: adapters live
// outside the React tree, so they record facts here and the handler hook reads
// them on end to emit events. Only one session runs at a time.

export interface DictationTelemetrySnapshot {
  transcriptLength: number;
  errorType?: string;
}

let state: DictationTelemetrySnapshot = { transcriptLength: 0 };
let transcript = '';

export function resetDictationTelemetry(): void {
  state = { transcriptLength: 0 };
  transcript = '';
}

export function setDictationTranscriptLength(length: number): void {
  if (state.transcriptLength === length) return;
  state.transcriptLength = length;
}

export function setDictationTranscript(text: string): void {
  transcript = text;
}

// Cleared on read so a transcript is attributed to only one sent message.
export function consumeDictationTranscript(): string {
  const text = transcript;
  transcript = '';
  return text;
}

// A send is "dictated" when it contains the consumed transcript (possibly edited
// around) — the substring match the dashboard uses to mark it as submitted.
export function isDictatedSend({
  submittedText,
  transcript,
}: {
  submittedText?: string;
  transcript: string;
}): boolean {
  return !!transcript && !!submittedText && submittedText.includes(transcript);
}

export function setDictationErrorType(errorType: string): void {
  state.errorType = errorType;
}

export function getDictationTelemetry(): DictationTelemetrySnapshot {
  return { ...state };
}
